import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-map-pin-icon',
    imports: [],
    styles: [`:host { display: block; }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><path d="M15 10a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/></svg>`
})
export class MapPinIconComponent {}
